import config from '../config/age-restriction.json';
import type { MenuCategory, Product } from '../types/menu';

const normalize = (name: string) => name.trim().toLocaleLowerCase('ru-RU').replace(/\s+/g, ' ');
const names = new Set(config.categoryNames.map(normalize));
const ids = new Set<string>(config.categoryIds);

export const restrictedCategory = (category: Pick<MenuCategory, 'id' | 'name' | 'barSection'>) => category.barSection === true || ids.has(category.id) || names.has(normalize(category.name));
export const restrictedProduct = (product: Product, categories: MenuCategory[]) =>
  [product.category, ...(product.categories ?? [])].some(name => names.has(normalize(name)))
  || (product.categoryIds ?? []).some(id => ids.has(id))
  || categories.some(category => restrictedCategory(category) && category.productIds.includes(product.id));
